import React from 'react';
import AssignLenderLeadModal from '../../../components/Portfolio/AssignLenderLeadModal';
import Button from '../../../components/Common/Button';
import AddQueryModal from '../../../components/Portfolio/AddQueryModal';
import Modal from '../../../components/Common/Modal';
import { useNavigate, useParams } from 'react-router';
import LenderUgroService from '../../../services/lender';
import { toast } from 'react-toastify';
import message from '../../../constant/message';
import MasterDataService from '../../../services/master-data';
import FinalSubmitToLender from './FinalSubmitToLender';
import PreSanctionSubmitToLender from './PreSanctionSubmitTolender'
import SubmitToLender from './SubmitToLender';
import DirectSanctionToLender from './DirectSanctionToLender';
import PullBackModal from './PullBackModal';
import { objectsForEach } from '../../../common/objectToArray';
import OpsModal from './OpsModal';
import DisburseModal from './DisburseModal';
import RejectModal from './RejectModal';
import ApproveModal from './ApproveModal';
import ChangeStatus from './ChangeStatus';
import ChangeStatusOTC from './ChangeStatusOTC';

const PortfolioActions = ({
	state,
	updateLeadDetail,
	detailsResponse,
	detailLenderId,
	detailLenderName,
	toggleAssignModalMapLender
}) => {
	const [assignModalState, setAssignModalState] = React.useState(false);
	const [showRejectModal, setShowRejectModal] = React.useState(false);
	const [showApproveModal, setShowApproveModal] = React.useState(false);
	const [showPullBackConfirm, setShowPullBackConfirm] = React.useState(false);

	const [queryOptions, setQueryOptions] = React.useState([]);
	const [opsActionType, setOpsActionType] = React.useState();
	const [detailresponse, setDetailsResponse] = React.useState();
	const [showQueryButtons, setShowQueryButtons] = React.useState(false);
	const [detailInfo, setDetailInfo] = React.useState(null);
	const [showFinalSubmitModal, setShowFinalSubmitModal] = React.useState(false);
	const [showSanctionModal, setShowSanctionModal] = React.useState(false);
	const [showChangeStatusModal, setshowChangeStatusModal] = React.useState(false)
	const [showChangeStatusOTCModal, setshowChangeStatusOTCModal] = React.useState(false);
	const [showFinalSubmitButton, setshowFinalSubmitButton] =
		React.useState(false);
	const [showSubmitToLenderModal, setShowSubmitToLenderModal] =
		React.useState(false);
	const [showPreSanctionSubmitToLenderModal, setShowPreSanctionSubmitToLenderModal] =
		React.useState(false);
	const [modalState, setModalState] = React.useState(false);
	const [showOpsModal, setOpsModalState] = React.useState(false);
	const [showDisburseModal, setDisburseModalState] = React.useState(false);
	const [finalSubmitToUgro, setFinalSubmitToUgro] = React.useState(false)
	const navigate = useNavigate();
	const leadId = useParams()['id'];
	const [selectedColender,setSelectedCoender] = React.useState(localStorage.getItem('selectedColender'))	

	const toggleAssignModal = () => {
		setAssignModalState(!assignModalState);
	};
	const toggleRejectModal = () => {
		setShowRejectModal(!showRejectModal);
	};
	const toggleApproveModal = () => {
		setShowApproveModal(!showApproveModal);
	};
	const toggleFinalSubmitModal = () => {
		setShowFinalSubmitModal(!showFinalSubmitModal);
	};
	const toggleSanctionModal = () => {
		setShowSanctionModal(!showSanctionModal);
	};
	const toggleChangeStatus = () => {
		setshowChangeStatusModal(!showChangeStatusModal)
	}
	const toggleChangeStatusOTC = () => {
		setshowChangeStatusOTCModal(!showChangeStatusOTCModal)
	}
	const toggleSubmitToLenderModal = () => {
		setShowSubmitToLenderModal(!showSubmitToLenderModal);
	};
	const togglePreSanctionSubmitToLenderModal = () => {
		setShowPreSanctionSubmitToLenderModal(!showPreSanctionSubmitToLenderModal);
	};


	const toggleOpsModal = (type) => {
		setOpsActionType(type);
		setOpsModalState(!showOpsModal);
	};
	const toggleDisburseModal = (type) => {
		setDisburseModalState(!showDisburseModal);
	};
	const togglePullBackModal = () => {
		setShowPullBackConfirm(!showPullBackConfirm);
	};
	const getQueryOptions = async () => {
		const response = await MasterDataService.getProductList(state.userType, '');
		if (response?.data?.status?.code === 1) {
			setQueryOptions(response.data.data.query_type);
		}
	};
	React.useEffect(() => {
		getPreapprovedLenders();
	}, []);
	const getPreapprovedLenders = async () => {
		try {
			const response = await MasterDataService.getPreapprovedLenders(
				state.userType,
				'co-lender',
				leadId
			);

			let responseList = objectsForEach(
				response.data.data.lender_list,
				'STRING_VAL'
			);
			let lenderItems = responseList.map((response) => ({
				label: response.value,
				value: response.id,
			}));

			if (lenderItems.length === 0) {
			} else {
				setshowFinalSubmitButton(true);
			}
		} catch (err) {
			console.log(err);
		}
	};

	const toggleModal = () => {
		setModalState(!modalState);
	};

	const getLeadDetail = async (assignCallback) => {
		const response = await LenderUgroService.getPortfolioDetail({
			type: state.userType,
			leadId,
			lenderId: detailLenderId,
		});
		// console.log(response?.data?.data?.details)
		setDetailsResponse(response?.data?.data?.details);
		setShowQueryButtons(
			response?.data?.data?.details?.cl_lead_lender_status === 2 ||
			response?.data?.data?.details?.cl_lead_lender_status === 5
		);
		if (assignCallback) {
			updateLeadDetail(response?.data?.data?.details);
			redirectToAdditional(response?.data?.data?.details.cl_lead_id);
		}
	};

	const checkHasPermission = (checkPermission) => {
		if (state.is_super_admin === 1) return true;
		const permission = state.permission.find(
			(permission) => permission === checkPermission
		);

		if (permission) return true;
		else return false;
	};

	const redirectToAssigned = () => navigate('/portfolio/assigned');
	const redirectToAdditional = (leadId) => {
		// navigate('/portfolio/view/' + leadId + '/additional');
	};
	const getLeadDetailInfo = async () => {
		const response = await LenderUgroService.getLeadDetailInfo({
			type: state.userType,
			leadId: leadId,
		});
		setDetailInfo(response?.data?.data?.details);
	};

	React.useLayoutEffect(() => {
		getLeadDetail();
		if (state.userType !== 'admin') {
			getQueryOptions();
		}
		if (state.userType == 'lender') {
			getLeadDetailInfo();
		}
	}, []);

	const isAssignedToUgro = () => {
		let flag = false;
		let data = detailresponse?.cl_lead_status;
		data?.map((item) => {
			if ([6, 7]?.includes(item?.id) && item?.lender_id === 9) {
				flag = true;
			}
		})
		return flag;
	}

	return (
		<>
			<div class='row justify-content-end no-gutters col-md-6'>
				{Boolean(state.userType === 'admin') && (
					<div class='col-3'>
						<div className='d-flex justify-content-end'>
							{/* {Boolean(
										state.userType === 'admin' &&
										checkHasPermission('assign-colender-lead') &&
										(selectedColender !== '/da/pool-selection-filter' && selectedColender !== '/da/decision-pending' && selectedColender !== '/da/pool-assignment' && selectedColender !== '/da/final-list' ) &&
										(![6,9,10,11,15].includes(detailsResponse?.cl_lead_lender_status))
									) && (
											<button
												onClick={toggleAssignModalMapLender}
												class='btn btn-custom btn-custom-height mr-1'
												type='button'
												data-toggle='modal'
												data-target='#exampleModalCenter'
											>
												Map Co-lender
											</button>

										)} */}
									{Boolean(
										state.userType === 'admin' &&
										checkHasPermission('assign-colender-lead') &&
										(selectedColender !== '/da/pool-selection-filter' && selectedColender !== '/da/decision-pending' && selectedColender !== '/da/pool-assignment' && selectedColender !== '/da/final-list' ) &&
										(![6,7,9,10,15,18,19,20].includes(detailsResponse?.cl_lead_lender_status) && !(isAssignedToUgro()) && detailsResponse?.cl_lead?.lead_type === 1)
									) && <>
											{checkHasPermission('sanction-approve-to-ugro') && <button
												onClick={() => {
													setFinalSubmitToUgro(true)
													toggleFinalSubmitModal()
												}}
												class='btn btn-custom btn-custom-height mr-1'
												type='button'
												data-toggle='modal'
												data-target='#exampleModalCenter'
											>
												{/* Sanction Approve to Ugro */}
												Remove From Co-lending
											</button>}
										</>}
									{/* {(
										!([6,8,9,10,15]?.includes(detailsResponse?.cl_lead_lender_status) ||
											(detailLenderName || []).includes('Ugro Capital'))) &&
											(selectedColender !== '/da/pool-selection-filter' && selectedColender !== '/da/decision-pending' && selectedColender !== '/da/pool-assignment' && selectedColender !== '/da/final-list' ) &&
										checkHasPermission('pulled-back-application') && (
											<button
												onClick={togglePullBackModal}
												class='btn btn-custom btn-custom-height'
												type='button'
												data-toggle='modal'
												data-target='#exampleModalCenter'
											>
												Pull Back
											</button>
										)} */}
									{checkHasPermission('submit-to-lender') &&
										state.userType === 'admin' &&
										(selectedColender !== '/da/pool-selection-filter' && selectedColender !== '/da/decision-pending' && selectedColender !== '/da/pool-assignment' && selectedColender !== '/da/final-list' ) &&
										(detailsResponse?.cl_lead_lender_status === 3 || (detailsResponse?.is_additional_info_req == 2 && detailsResponse?.cl_lead_lender_status === 2)) && (
											<>
												<button
													onClick={toggleSubmitToLenderModal}
													class='btn btn-custom btn-custom-height ml-1'
													type='button'
													data-toggle='modal'
													data-target='#exampleModalCenter'
												>
													{/* {detailsResponse?.cl_lead?.application_status === 'Pre-Sanctioned' ? 'Submit  to Lender Pre Sanction' : 'Submit  to Lender'} */}
													Submit To Lender
												</button>
											</>
										)}

									{checkHasPermission('submit-to-lender') &&
										state.userType === 'admin' &&
										(selectedColender !== '/da/pool-selection-filter' && selectedColender !== '/da/decision-pending' && selectedColender !== '/da/pool-assignment' && selectedColender !== '/da/final-list' ) &&
										detailsResponse?.cl_lead_lender_status === 13 && (
											<>
												<button
													onClick={togglePreSanctionSubmitToLenderModal}
													class='btn btn-custom btn-custom-height ml-1'
													type='button'
													data-toggle='modal'
													data-target='#exampleModalCenter'
												>
													Submit To Lender
												</button>
											</>
										)}
									{checkHasPermission('submit-to-lender') &&
										state.userType === 'admin' &&
										detailLenderId === '23' &&
										detailsResponse?.cl_lead?.lead_type === 2 &&
										detailsResponse?.cl_lead_lender_status === 4 && (
											<>
												<button
													onClick={toggleSanctionModal}
													class='btn btn-custom btn-custom-height ml-1'
													type='button'
													data-toggle='modal'
													data-target='#exampleModalCenter'
												>
													Sanction
												</button>
											</>
										)}
									{checkHasPermission('disburse-otc-reject') &&
										state.userType === 'admin' &&
										detailsResponse?.cl_lead_lender_status === 6 &&
										detailLenderId == 21 &&
										detailsResponse?.cl_lead_for_disbursal === null && (
											<button
												onClick={toggleChangeStatusOTC}
												className='btn btn-custom btn-custom-height ml-1'
												type='button'
												data-toggle='modal'
												data-target='#exampleModalCenter'
											>
												Disbursement Pending with OTC
											</button>
										)}
									{checkHasPermission('disburse-otc-reject') &&
										state.userType === 'admin' &&
										detailLenderId != 23 &&
										(selectedColender !== '/da/pool-selection-filter' && selectedColender !== '/da/decision-pending' && selectedColender !== '/da/pool-assignment' && selectedColender !== '/da/final-list' ) &&
										[6,19].includes(detailsResponse?.cl_lead_lender_status) &&
										detailsResponse?.cl_lead_for_disbursal === null && (
											<button
												onClick={toggleChangeStatus}
												className='btn btn-custom btn-custom-height ml-1'
												type='button'
												data-toggle='modal'
												data-target='#exampleModalCenter'
											>
												Initiate Disbursement
											</button>
										)}
									{checkHasPermission('disbursed') &&
										state.userType === 'admin' &&
										((detailsResponse?.cl_lead_lender_status === 10 &&
										detailLenderId == 21) || (detailsResponse?.cl_lead_lender_status === 9 &&
										detailLenderId == 23)) &&
										detailsResponse?.cl_lead_for_disbursal === null && (
											<button
												onClick={() => toggleDisburseModal('disburse')}
												className='btn btn-custom btn-custom-height ml-1'
												type='button'
												data-toggle='modal'
												data-target='#exampleModalCenter'
											>
												Disburse
											</button>
										)}
									{checkHasPermission('final-submit-to-lender') &&
										state.userType === 'admin' &&
										(selectedColender !== '/da/pool-selection-filter' && selectedColender !== '/da/decision-pending' && selectedColender !== '/da/pool-assignment' && selectedColender !== '/da/final-list' ) &&
										showFinalSubmitButton &&
										detailsResponse?.cl_lead_lender_status === 7 && (
											<button
												onClick={toggleFinalSubmitModal}
												className='btn btn-custom btn-custom-height ml-1'
												type='button'
												data-toggle='modal'
												data-target='#exampleModalCenter'
											>
												Final Submit to Lender
											</button>
										)}
								</div>
								{/* {showPullBackConfirm && (
									<PullBackModal
										modelState={showPullBackConfirm}
										toggleModal={togglePullBackModal}
										getLeadDetail={getLeadDetail}
										toggleRejectModal={toggleRejectModal}
										leadType={detailsResponse?.cl_lead?.lead_type || ''}
									/>
								)} */}
					</div>
				)}
			</div>

			{(state.userType === 'admin'
				? detailsResponse?.cl_lead_lender_status === 6 &&
				detailsResponse?.cl_lead_eligible_for_disbursal
				: checkHasPermission('disburse-reject') &&
				detailInfo?.cl_lead_lender_status === 6 &&
				(selectedColender !== '/da/pool-selection-filter' && selectedColender !== '/da/decision-pending' && selectedColender !== '/da/pool-assignment' && selectedColender !== '/da/final-list' ) &&
				detailInfo?.cl_lead_eligible_for_disbursal) && (
					<div class='col-3'>
						<div className='d-flex justify-content-end'>
							<button
								onClick={() => toggleOpsModal('approve')}
								class='btn btn-custom ml-2'
								type='button'
							>
								Disburse
							</button>
							<button
								onClick={() => toggleOpsModal('reject')}
								class='btn btn-custom btn-custom-height ml-2'
								type='button'
							>
								Reject
							</button>
						</div>
					</div>
				)}
			{showOpsModal && opsActionType && (
				<OpsModal
					state={showOpsModal}
					actionType={opsActionType}
					toggleModal={toggleOpsModal}
					leadId={leadId}
					userType={state.userType}
				/>
			)}
			{showFinalSubmitModal && (
				<FinalSubmitToLender
					modelState={showFinalSubmitModal}
					toggleModal={toggleFinalSubmitModal}
					detailLenderName={detailLenderName}
					submitToUgro={finalSubmitToUgro}
				/>
			)}
			{showDisburseModal && (
				<DisburseModal
					modelState={showDisburseModal}
					toggleModal={toggleDisburseModal}
					detailLenderId={detailLenderId}
					detailLenderName={detailLenderName}
					userType={state.userType}
				/>
			)}
			{showPreSanctionSubmitToLenderModal && (
				<PreSanctionSubmitToLender
					modelState={showPreSanctionSubmitToLenderModal}
					toggleModal={togglePreSanctionSubmitToLenderModal}
					detailLenderId={detailLenderId}
					detailLenderName={detailLenderName}
					getLeadDetail={getLeadDetail}
				/>
			)}
			{showSubmitToLenderModal && (
				<SubmitToLender
					modelState={showSubmitToLenderModal}
					toggleModal={toggleSubmitToLenderModal}
					detailLenderId={detailLenderId}
					detailLenderName={detailLenderName}
					getLeadDetail={getLeadDetail}
					detailsResponse={detailsResponse}
				/>
			)}
			{showSanctionModal && (
				<DirectSanctionToLender
					modelState={showSanctionModal}
					toggleModal={toggleSanctionModal}
					detailLenderId={detailLenderId}
					detailLenderName={detailLenderName}
					getLeadDetail={getLeadDetail}
					detailsResponse={detailsResponse}
				/>
			)}
			{showChangeStatusModal && (
				<ChangeStatus
					modelState={showChangeStatusModal}
					toggleModal={toggleChangeStatus}
					detailLenderId={detailLenderId}
					detailLenderName={detailLenderName}
					getLeadDetail={getLeadDetail}
				/>
			)}
			{showChangeStatusOTCModal && (
				<ChangeStatusOTC
					modelState={showChangeStatusOTCModal}
					toggleModal={toggleChangeStatusOTC}
					detailLenderId={detailLenderId}
					detailLenderName={detailLenderName}
					getLeadDetail={getLeadDetail}
				/>
			)}
			{state.userType === 'lender' &&
				checkHasPermission('sanction-reject') &&
				detailsResponse &&
				(selectedColender !== '/da/pool-selection-filter' && selectedColender !== '/da/decision-pending' && selectedColender !== '/da/pool-assignment' && selectedColender !== '/da/final-list' ) &&
				detailsResponse?.cl_lead_lender_status === 4 ? (
				<>
					<div className='d-flex align-items-center mt-3'>
						<Button
							type='btn-custom'
							classNames='small'
							clickHandler={() => setShowApproveModal(true)}
						>
							Sanction
						</Button>
						<Button
							clickHandler={() => setShowRejectModal(true)}
							classNames='btn-outline-custom small text-orange ml-2 mr-2'
						>
							Reject
						</Button>
						{showQueryButtons && (
							<Button
								clickHandler={toggleModal}
								classNames='btn-outline-custom small text-orange mr-2'
							>
								Query
							</Button>
						)}
					</div>

					{modalState && (
						<AddQueryModal
							userType={state.userType}
							state={modalState}
							toggleModal={toggleModal}
							queryOptions={queryOptions}
							leadId={leadId}
							globalState={state}
						/>
					)}

					{showRejectModal && (
						<RejectModal
							showRejectModal={showRejectModal}
							leadId={leadId}
							userType={state.userType}
							toggleRejectModal={toggleRejectModal}
							redirectToAssigned={redirectToAssigned}
						/>
					)}

					{showApproveModal && (
						<ApproveModal
							leadId={leadId}
							userType={state.userType}
							showApproveModal={showApproveModal}
							toggleApproveModal={toggleApproveModal}
							redirectToAssigned={redirectToAssigned}
						/>
					)}
				</>
			) : (
				''
			)}
			{state.userType !== 'lender' && assignModalState ? (
				<AssignLenderLeadModal
					modelState={assignModalState}
					toggleModal={toggleAssignModal}
					reloadTable={() => getLeadDetail(true)}
					colenders={[]}
					selectedIds={[leadId]}
					leadType={detailsResponse?.cl_lead?.lead_type || ''}
					type='details'
				/>
			) : (
				''
			)}
		</>
	);
};

export default PortfolioActions;
